(function () {
  'use strict';

  function rupees(cents) {
    var n = Math.round(cents) / 100;
    return '₹' + n.toLocaleString('en-IN');
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Toast ---------- */
  var toastEl = qs('[data-mf-toast]');
  var toastTimer = null;
  function flash(msg) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- Mobile nav toggle ---------- */
  var navRow = qs('[data-mf-nav-row]');
  qsa('[data-mf-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!navRow) return;
      navRow.classList.toggle('is-open');
      if (searchRow) searchRow.classList.remove('is-open');
    });
  });
  qsa('[data-mf-nav-link]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (navRow) navRow.classList.remove('is-open');
    });
  });

  /* ---------- Search toggle ---------- */
  var searchRow = qs('[data-mf-search-row]');
  qsa('[data-mf-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchRow) return;
      searchRow.classList.toggle('is-open');
      if (navRow) navRow.classList.remove('is-open');
      if (searchRow.classList.contains('is-open')) {
        var input = qs('[data-mf-search-input]');
        if (input) input.focus();
      } else {
        var input2 = qs('[data-mf-search-input]');
        if (input2) { input2.value = ''; applyFilters(); }
      }
    });
  });

  /* ---------- Wishlist (in-memory) ---------- */
  var wished = {};
  var wishCountEl = qs('[data-mf-wish-count]');
  function updateWishCount() {
    if (wishCountEl) wishCountEl.textContent = Object.keys(wished).filter(function (k) { return wished[k]; }).length;
  }
  qsa('[data-mf-wish-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var product = btn.closest('[data-mf-product]');
      var id = product ? product.id : Math.random().toString(36);
      wished[id] = !wished[id];
      var off = qs('[data-mf-wish-off]', btn);
      var on = qs('[data-mf-wish-on]', btn);
      if (wished[id]) {
        if (off) off.style.display = 'none';
        if (on) on.style.display = 'block';
      } else {
        if (off) off.style.display = 'block';
        if (on) on.style.display = 'none';
      }
      updateWishCount();
    });
  });

  /* ---------- Hero ---------- */
  var heroSlides = qsa('[data-mf-hero-slide]');
  var heroCopies = qsa('[data-mf-hero-copy]');
  var heroDots = qsa('[data-mf-hero-dot]');
  var heroPlate = qs('[data-mf-hero-plate]');
  var heroIndex = 0;
  var heroTimer = null;

  function showHeroSlide(i) {
    heroIndex = i;
    heroSlides.forEach(function (el) { el.style.opacity = (Number(el.getAttribute('data-index')) === i) ? '1' : '0'; });
    heroCopies.forEach(function (el) { el.style.display = (Number(el.getAttribute('data-index')) === i) ? 'flex' : 'none'; });
    heroDots.forEach(function (el) { el.style.background = (Number(el.getAttribute('data-index')) === i) ? '#000000' : '#cccccc'; });
  }
  function startHeroTimer() {
    clearInterval(heroTimer);
    if (!heroSlides.length) return;
    heroTimer = setInterval(function () {
      showHeroSlide((heroIndex + 1) % heroSlides.length);
    }, 6500);
  }
  heroDots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      showHeroSlide(Number(dot.getAttribute('data-index')));
      startHeroTimer();
    });
  });
  if (heroSlides.length) startHeroTimer();

  window.addEventListener('pointermove', function (e) {
    var w = window.innerWidth, h = window.innerHeight;
    var tiltY = ((e.clientX / w) - 0.5) * 10;
    var tiltX = -((e.clientY / h) - 0.5) * 6;
    heroSlides.forEach(function (el) {
      el.style.transform = 'translate3d(' + (tiltY * -1.2).toFixed(2) + 'px,' + (tiltX * -1.2).toFixed(2) + 'px,0) scale(1.06)';
    });
    if (heroPlate) {
      heroPlate.style.transform = 'perspective(1200px) rotateX(' + (tiltX * 0.35).toFixed(2) + 'deg) rotateY(' + (tiltY * 0.35).toFixed(2) + 'deg)';
    }
    if (dragging) return;
    prismSpin += 0;
  });

  /* ---------- Prism drag-to-spin ---------- */
  var prismWrap = qs('[data-mf-prism-wrap]');
  var prism = qs('[data-mf-prism]');
  var prismSpin = 0;
  var dragging = false;
  var autoSpinTimer = null;

  function renderPrism() {
    if (!prism) return;
    prism.style.transform = 'translateZ(-320px) rotateX(-4deg) rotateY(' + prismSpin.toFixed(2) + 'deg)';
  }
  function startAutoSpin() {
    clearInterval(autoSpinTimer);
    autoSpinTimer = setInterval(function () {
      if (dragging) return;
      prismSpin += 0.22;
      renderPrism();
    }, 32);
  }
  if (prismWrap && prism) {
    startAutoSpin();
    prismWrap.addEventListener('pointerdown', function (e) {
      dragging = true;
      prismWrap.style.cursor = 'grabbing';
      prismWrap.setPointerCapture && prismWrap.setPointerCapture(e.pointerId);
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      prismSpin += (e.movementX || 0) * 0.35;
      renderPrism();
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
      if (prismWrap) prismWrap.style.cursor = 'grab';
    });
  }

  /* ---------- Product grid: tabs + search + swatches ---------- */
  var products = qsa('[data-mf-product]');
  var gridTitle = qs('[data-mf-grid-title]');
  var noResults = qs('[data-mf-no-results]');
  var resultLabel = qs('[data-mf-result-label]');
  var searchInput = qs('[data-mf-search-input]');
  var activeTab = 'all';

  var TAB_TITLES = {
    all: 'New and trending',
    '01': 'Collection 01, Off Duty Performance',
    '02': 'Collection 02, Motivation and Community',
    '03': 'Collection 03, Fun and Personality',
    basics: 'Basics, blanks and hoodies'
  };

  function applyFilters() {
    var q = (searchInput && searchInput.value || '').trim().toLowerCase();
    var shown = 0;
    products.forEach(function (p) {
      var tab = p.getAttribute('data-tab');
      var tabOk = activeTab === 'all' ? tab !== 'basics' : tab === activeTab;
      var hay = p.getAttribute('data-search') || '';
      var qOk = !q || hay.indexOf(q) >= 0;
      var visible = tabOk && qOk;
      p.style.display = visible ? 'flex' : 'none';
      if (visible) shown++;
    });
    if (gridTitle) gridTitle.textContent = q ? 'Search results' : (TAB_TITLES[activeTab] || 'New and trending');
    if (noResults) noResults.style.display = shown === 0 ? 'block' : 'none';
    if (resultLabel) resultLabel.textContent = shown + (shown === 1 ? ' item' : ' items');
  }

  function setTab(tab) {
    activeTab = tab;
    qsa('[data-mf-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-mf-tab') === tab;
      btn.style.background = on ? '#000000' : '#ffffff';
      btn.style.color = on ? '#ffffff' : '#000000';
    });
    applyFilters();
  }

  qsa('[data-mf-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () { setTab(btn.getAttribute('data-mf-tab')); });
  });
  qsa('[data-mf-collection-pick]').forEach(function (link) {
    link.addEventListener('click', function () { setTab(link.getAttribute('data-tab')); });
  });
  if (searchInput) searchInput.addEventListener('input', applyFilters);
  applyFilters();

  qsa('[data-mf-swatch]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var product = btn.closest('[data-mf-product]');
      if (!product) return;
      qsa('[data-mf-swatch]', product).forEach(function (b) { b.style.border = '1px solid #cccccc'; });
      btn.style.border = '1px solid #000000';
      var isLight = btn.getAttribute('data-light') === 'true';
      var photo = qs('[data-mf-photo]', product);
      var swatchImage = btn.getAttribute('data-image');
      if (photo && swatchImage) {
        photo.src = swatchImage;
        if (photo.alt !== undefined) photo.alt = btn.getAttribute('data-name') || photo.alt;
      }
      var blank = qs('[data-mf-blank-block]', product);
      if (blank) {
        blank.style.background = btn.getAttribute('data-hex');
        var label = qs('[data-mf-blank-label]', product);
        if (label) { label.textContent = btn.getAttribute('data-name'); label.style.color = isLight ? '#333333' : '#ffffff'; }
        var wishBtn = qs('[data-mf-wish-toggle]', product);
        if (wishBtn) wishBtn.style.color = isLight ? '#000000' : '#ffffff';
      }
    });
  });

  /* ---------- Cart ---------- */
  var bagDrawer = qs('[data-mf-bag-drawer]');
  var bagCountEls = qsa('[data-mf-bag-count], [data-mf-bag-count-title]');
  var bagItemsWrap = qs('[data-mf-bag-items]');
  var subtotalEl = qs('[data-mf-subtotal]');

  function openBag() { if (bagDrawer) bagDrawer.classList.add('is-open'); }
  function closeBag() { if (bagDrawer) bagDrawer.classList.remove('is-open'); }
  qsa('[data-mf-bag-open]').forEach(function (b) { b.addEventListener('click', openBag); });
  qsa('[data-mf-bag-close]').forEach(function (b) { b.addEventListener('click', closeBag); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeBag(); if (searchRow) searchRow.classList.remove('is-open'); }
  });

  function renderCart(cart) {
    bagCountEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = rupees(cart.total_price);
    if (!bagItemsWrap) return;
    if (cart.item_count === 0) {
      bagItemsWrap.innerHTML = '<p style="margin:0;padding:24px 0;font-size:15px;font-weight:400;line-height:1.45;letter-spacing:0.3px;color:#333333">Your bag is empty.</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, idx) {
      var line = idx + 1;
      var img = item.image ? '<img src="' + item.image + '" alt="" style="width:72px;height:90px;object-fit:cover;border-radius:0;background:#e5e7eb;flex:none">' : '<span style="width:72px;height:90px;flex:none;border:1px solid #e5e7eb;background:#f0efe7"></span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? ' &middot; ' + item.variant_title : '';
      html += '<div style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid #e5e7eb;align-items:flex-start">' +
        img +
        '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:4px">' +
        '<span style="font-size:13px;font-weight:400;line-height:1.4">' + item.product_title + variant + '</span>' +
        '<span style="font-size:13px;font-weight:500;line-height:1.4">' + rupees(item.final_line_price) + '</span>' +
        '<div style="display:flex;align-items:center;gap:12px;padding-top:4px">' +
        '<button type="button" data-mf-qty-dec data-line="' + line + '" aria-label="Decrease quantity" style="width:24px;height:24px;border:1px solid #000000;border-radius:4px;background:none;font-size:12px;line-height:1;color:#000000">&minus;</button>' +
        '<span style="font-size:12px;font-weight:500">' + item.quantity + '</span>' +
        '<button type="button" data-mf-qty-inc data-line="' + line + '" aria-label="Increase quantity" style="width:24px;height:24px;border:1px solid #000000;border-radius:4px;background:none;font-size:12px;line-height:1;color:#000000">+</button>' +
        '<button type="button" data-mf-qty-remove data-line="' + line + '" style="margin-left:auto;background:none;border:0;font-size:10px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#333333;padding:4px">Remove</button>' +
        '</div></div></div>';
    });
    bagItemsWrap.innerHTML = html;
    bindCartRowEvents();
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function bindCartRowEvents() {
    qsa('[data-mf-qty-inc]', bagItemsWrap).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(Number(b.getAttribute('data-line')), 1); });
    });
    qsa('[data-mf-qty-dec]', bagItemsWrap).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(Number(b.getAttribute('data-line')), -1); });
    });
    qsa('[data-mf-qty-remove]', bagItemsWrap).forEach(function (b) {
      b.addEventListener('click', function () { setLineQty(Number(b.getAttribute('data-line')), 0); });
    });
  }

  function setLineQty(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  var lineQtyCache = {};
  function changeLine(line, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items[line - 1];
      if (!item) return;
      var next = Math.max(0, item.quantity + delta);
      setLineQty(line, next);
    });
  }

  bindCartRowEvents();

  /* ---------- Full cart page (/cart) ---------- */
  function pageSetLineQty(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { window.location.reload(); });
  }
  qsa('[data-mf-page-qty-inc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var line = Number(b.getAttribute('data-line'));
      var qtyEl = b.previousElementSibling;
      var current = qtyEl ? Number(qtyEl.textContent) : 1;
      pageSetLineQty(line, current + 1);
    });
  });
  qsa('[data-mf-page-qty-dec]').forEach(function (b) {
    b.addEventListener('click', function () {
      var line = Number(b.getAttribute('data-line'));
      var qtyEl = b.nextElementSibling;
      var current = qtyEl ? Number(qtyEl.textContent) : 1;
      pageSetLineQty(line, Math.max(0, current - 1));
    });
  });
  qsa('[data-mf-page-qty-remove]').forEach(function (b) {
    b.addEventListener('click', function () {
      pageSetLineQty(Number(b.getAttribute('data-line')), 0);
    });
  });

  /* ---------- Product page (size + colour selection, add to bag) ---------- */
  var pdp = qs('[data-mf-pdp]');
  if (pdp) {
    var pdpVariantsEl = qs('[data-mf-pdp-variants]');
    var pdpVariants = pdpVariantsEl ? JSON.parse(pdpVariantsEl.textContent) : [];
    var pdpState = { color: pdp.getAttribute('data-initial-color'), size: null };
    var pdpPriceEl = qs('[data-mf-pdp-price]');
    var pdpAddBtn = qs('[data-mf-pdp-add]');
    var pdpErrorEl = qs('[data-mf-pdp-error]');
    var pdpQtyInput = qs('[data-mf-pdp-qty]');
    var pdpAddDefaultLabel = pdpAddBtn ? pdpAddBtn.textContent : 'Add to bag';

    function pdpFindVariant() {
      for (var i = 0; i < pdpVariants.length; i++) {
        if (pdpVariants[i].option1 === pdpState.color && pdpVariants[i].option2 === pdpState.size) return pdpVariants[i];
      }
      return null;
    }
    function pdpUpdate() {
      var v = pdpFindVariant();
      if (v && pdpPriceEl) pdpPriceEl.textContent = rupees(v.price);
      if (v && pdpAddBtn) {
        pdpAddBtn.disabled = !v.available;
        if (!v.available) pdpAddBtn.textContent = 'Sold out';
        else if (pdpAddBtn.textContent === 'Sold out') pdpAddBtn.textContent = pdpAddDefaultLabel;
      }
    }
    qsa('[data-mf-pdp-color]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pdpState.color = btn.getAttribute('data-color');
        qsa('[data-mf-pdp-color]').forEach(function (b) { b.style.border = '1px solid #cccccc'; });
        btn.style.border = '1px solid #000000';
        var img = qs('[data-mf-pdp-photo]');
        var imgUrl = btn.getAttribute('data-image');
        if (img && imgUrl) img.src = imgUrl;
        pdpUpdate();
      });
    });
    qsa('[data-mf-pdp-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pdpState.size = btn.getAttribute('data-size');
        qsa('[data-mf-pdp-size]').forEach(function (b) { b.style.background = '#ffffff'; b.style.color = '#000000'; });
        btn.style.background = '#000000';
        btn.style.color = '#ffffff';
        if (pdpErrorEl) pdpErrorEl.style.display = 'none';
        pdpUpdate();
      });
    });
    var pdpQtyDec = qs('[data-mf-pdp-qty-dec]');
    var pdpQtyInc = qs('[data-mf-pdp-qty-inc]');
    if (pdpQtyDec) pdpQtyDec.addEventListener('click', function () {
      if (!pdpQtyInput) return;
      pdpQtyInput.value = Math.max(1, (Number(pdpQtyInput.value) || 1) - 1);
    });
    if (pdpQtyInc) pdpQtyInc.addEventListener('click', function () {
      if (!pdpQtyInput) return;
      pdpQtyInput.value = (Number(pdpQtyInput.value) || 1) + 1;
    });
    if (pdpAddBtn) pdpAddBtn.addEventListener('click', function () {
      if (!pdpState.size) {
        if (pdpErrorEl) pdpErrorEl.style.display = 'block';
        return;
      }
      var v = pdpFindVariant();
      if (!v || !v.available) return;
      var qty = pdpQtyInput ? Math.max(1, Number(pdpQtyInput.value) || 1) : 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      }).then(function (r) { return r.json(); }).then(function () {
        flash('Added. ' + v.name);
        fetchCart();
        openBag();
      });
    });
  }

  /* ---------- Noop buttons (account/wishlist placeholders, chat) ---------- */
  qsa('[data-mf-noop]').forEach(function (b) { b.addEventListener('click', function () {}); });
})();
